import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Save01 } from 'untitledui-js-base';
import { RentalCarConditionParam } from '../types/rental';

interface RentalCarInfoDialogProps {
  open: boolean;
  onClose?: () => void;
  formData?: RentalCarConditionParam[];
  onSubmit: (data: Record<string, any>) => void;
  isLoading?: boolean;
}

export const RentalCarInfoDialog = ({ formData, onSubmit, open, onClose, isLoading }: RentalCarInfoDialogProps) => {
  const methods = useForm<Record<string, any>>({
    shouldUnregister: true,
    defaultValues: {}
  });

  const {
    handleSubmit,
    control,
    formState: { errors },
    reset
  } = methods;

  useEffect(() => {
    if (open && formData && formData.length > 0) {
      const defaults: Record<string, any> = {};
      formData.forEach((item) => {
        defaults[item.name] = item.value !== undefined && item.value !== null ? item.value : '';
      });
      reset(defaults);
    }
  }, [formData, reset, open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg">
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle id="alert-dialog-title">Doplňte údaje</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} mt={2}>
            {formData?.map((field) => {
              const isValue = field.type === 'value';
              const isOption = field.type === 'option';

              return (
                <Grid key={field.name} size={{ xs: 12, md: 6 }}>
                  {isValue && (
                    <Controller
                      name={field.name}
                      control={control}
                      render={({ field: controllerField }) => (
                        <TextField
                          fullWidth
                          label={field.label}
                          value={controllerField.value}
                          onChange={controllerField.onChange}
                          error={Boolean(errors[field.name])}
                          helperText={errors[field.name]?.message as string}
                        />
                      )}
                    />
                  )}

                  {isOption && (
                    <FormControl fullWidth error={Boolean(errors[field.name])}>
                      <InputLabel id={`${field.name}-label`} sx={{ backgroundColor: 'white', px: 0.5 }}>
                        {field.label}
                      </InputLabel>
                      <Controller
                        name={field.name}
                        control={control}
                        render={({ field: selectField }) => (
                          <Select
                            {...selectField}
                            labelId={`${field.name}-label`}
                            label={field.label}
                            value={selectField.value ?? ''}
                          >
                            {field.options?.map((opt) => (
                              <MenuItem key={opt.value} value={opt.value as string}>
                                {opt.title}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors[field.name]?.message && (
                        <Typography variant="caption" color="error">
                          {errors[field.name]?.message as string}
                        </Typography>
                      )}
                    </FormControl>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            paddingBottom: 4,
            gap: 2,
            flexDirection: { xs: 'column-reverse', md: 'row' }
          }}
        >
          <Button onClick={onClose}>Zrušit</Button>
          <Button
            variant="contained"
            type="submit"
            color="success"
            startIcon={<Save01 size="20px" />}
            size="large"
            loading={isLoading}
          >
            Uložit a vygenerovat
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
